import React from 'react';
import { Image, ImageModifier } from '../../../../components/molecules/Image';
import { CarouselGallery } from '../Carousel/CarouselGallery';
import { CarouselListItem } from '../Carousel/CarouselListItem';
import { GalleryImage } from './ThumbnailGallery';

type GalleryProps = {
  id: string;
  images: GalleryImage[];
  focusedImageId?: string;
  ref?: React.RefObject<HTMLLIElement>;
};

export function PopupSliderGallery({ id, images, focusedImageId, ref }: GalleryProps) {
  return (
    <div className="image-gallery image-gallery--slider-in-popup">
      <CarouselGallery>
        {images.map(({ image }, index) => (
          <CarouselListItem
            key={`${id}-${image.imageId}`}
            id={id}
            total={images.length}
            currentIndex={index}
            ref={image.imageId === focusedImageId ? ref : undefined}
          >
            <Image
              image={image}
              lazyLoading
              responsiveType="imageGalleryImageInPopUp" // dedicated responsiveType to enable large images
              modifier={ImageModifier.SLIDER}
              hasPopUp
              isImageInPopUpSlider
            />
          </CarouselListItem>
        ))}
      </CarouselGallery>
    </div>
  );
}
